import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * The record a master–detail screen is showing, kept in the address.
 *
 * Deliberately shaped like `useState` so that the screens using it did not have
 * to be rewritten around it. What changes is where the answer lives: choosing a
 * part is now a step in the browser's history, which is what makes a phone's
 * back gesture step back through what you looked at instead of leaving the
 * application, and what makes a chosen record survive a reload.
 */
export function useSelectedId(base: string, search = ''): [string | null, (id: string | null) => void] {
  const { id } = useParams();
  const navigate = useNavigate();

  const select = useCallback(
    (next: string | null) => navigate({ pathname: next ? `${base}/${next}` : base, search }),
    [base, navigate, search],
  );

  return [id ?? null, select];
}
